import transfer from "../assets/transfer.gif";
import React, {useState} from "react";


function Loading({openHandle}: {openHandle: (agreement: boolean) => void})  {
    // function that counts down from 3 to 0 and displays the time left in the loading screen. Stop the counter at 0
    const [count, setCount] = React.useState(3);
    const [agreement, setAgreement] = useState(false);

    React.useEffect(() => {
        const timer = setTimeout(() => {
            if (count > 0) {
                setCount(count - 1);
            }
        }, 1000);
        return () => clearTimeout(timer);
    }, [count]);


    const handleChange = (event: any) => {
        setAgreement(event.target.checked);
    }

  return (
      <div className="window" style={loadingStyle.window}>
          <div className="title-bar">
              <div className="title-bar-text">Loading Dope Shop ...</div>
              <div className="title-bar-controls">
                  <button aria-label="Minimize"></button>
                  <button aria-label="Maximize"></button>
                  <button aria-label="Close"></button>
              </div>
          </div>
          <div>
              <img src={transfer} alt="loading" />
          </div>

          <div style={loadingStyle.body}>
              <div>Loading:</div>
              <div style={{padding: '10px 0'}}>dopeshop.exe from shop.skynet.be</div>
              <div className="status-bar" style={{width: '90%'}}>
                  <div className="status-bar-field">
                      <div className="loadingBar" style={{color: '#04047d'}}></div>
                  </div>
              </div>
              <div style={loadingStyle.body}>
                  {/*Make here three rows: estimated time left with 3 second counter, download destination and transfer rate*/}
                    <div style={{padding: '10px 0'}}>Estimated time left: {count} seconds ({(1-(count/3))*1810}KB of 1.81MB copied)</div>
                    <div style={{padding: '10px 0'}}>Download destination: C:\ProgramFiles\DopeShop.exe</div>
                  {count !== 0 ? (
                    <div style={{padding: '10px 0'}}>Transfer rate: 1.5 MB/s</div>
                    ) : (
                        <div style={loadingStyle.verification}>
                            <div style={{padding: '10px 0'}}>
                                <input type="checkbox" id="over18" name="over18" value="over18" onChange={handleChange} />
                                <label htmlFor="over18">I am over 18 years old</label>
                            </div>
                            <button
                                className="button"
                                style={{ padding: '10px 15px' }}
                                disabled={!agreement}
                                onClick={() => openHandle(true)}>
                                Open DopeShop -{'>'}
                            </button>
                        </div>
                  )}
              </div>
          </div>

          <div className="status-bar">
              <p className="status-bar-field">Press F1 for help</p>
              <p className="status-bar-field">Slide 1</p>
              <p className="status-bar-field">CPU Usage: 14%</p>
          </div>
      </div>
  );
}

const loadingStyle = {
    window: {
        width: "400px",
    },
    body: {
        display: "flex",
        flexDirection: "column" as "column",
        justifyContent: "flex-start",
        alignItems: "start",

        height: "200px",
        width: "100%",
        padding: "10px",
    },
    verification: {
        display: "flex",
        flexDirection: "row" as "row",
        justifyContent: "space-between",
        alignItems: "center",

        padding: "10px 0",
        width: "90%",
    }

};

export default Loading;
